import React from "react";
import './loadingBtn.css'

const LoadingBtn = () => {
  return (
    <div className="loading-in-modal-button">
      <div className="lds-dual-ring"></div>
    </div>
  );
};

export default LoadingBtn;
